import { useState } from "react";
import * as React from "react";
import UnAuthenticatedError from "./UnAuthenticatedError";
import { Image } from "@fluentui/react-components";
import { useAuth } from "./contexts/AuthContext";

const SidePanel = ({ value, onSelect }) => {
  return (
    <div
      style={{
        width: "25%",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        backgroundColor: "#092a45",
        padding: "1rem",
        color: "white",
        boxSizing: "border-box",
      }}
    >
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Image src={"assets/AlphaScript-logo.png"} alt="Alpha Script Logo" style={{ width: "70%" }} />
      </div>

      <ul style={{ listStyle: "none", padding: 0 }}>
        <li
          style={{
            marginBottom: "0.5rem",
            marginLeft: "0.5rem",
            cursor: "pointer",
            color: value === "sharePrice" ? "#ff5c35" : "#cecece",
          }}
          onClick={() => onSelect("sharePrice")}
        >
          Share Price Performance
        </li>
        <li
          style={{
            marginBottom: "0.5rem",
            marginLeft: "0.5rem",
            cursor: "pointer",
            color: value === "capitalization" ? "#ff5c35" : "#cecece",
          }}
          onClick={() => onSelect("capitalization")}
        >
          Capitalization
        </li>
      </ul>
    </div>
  );
};

export default function ProtectedRoute({
  authenticatedElement,
  unauthenticatedElement = <UnAuthenticatedError />,
  isPopup = false,
  isFirstStep,
}: {
  authenticatedElement: React.ReactNode;
  unauthenticatedElement?: React.ReactNode;
  isPopup?: boolean;
  isFirstStep?: boolean;
}) {
  //const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  const { isAuthenticated, isLoading } = useAuth();
  const [selectedOption, setSelectedOption] = useState("sharePrice");

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <>{unauthenticatedElement}</>;
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        minHeight: "100vh",
      }}
    >
      {isPopup && isFirstStep && <SidePanel value={selectedOption} onSelect={setSelectedOption} />}
      <div
        style={{
          width: isFirstStep ? "75%" : "100%",
          marginLeft: "auto",
        }}
      >
        {selectedOption === "sharePrice" ? authenticatedElement : "Dummy Capitalization"}
      </div>
    </div>
  );
}
